
import React from 'react'
import serverErrImg from '../../assets/serverError.png'
import sectionErrImg from '../../assets/serverErr.jpg'
import './css/serverError.css'
import { Card } from '@mui/material';

const ServerError = ({height}) => {
    return (
        //   <Card >
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <div className='server-err-div'
                style={{
                    width: "100%",
                    height: height||500,
                    display: "flex",
                    backgroundImage: `url(${serverErrImg})`,
                    backgroundSize: "contain",
                    backgroundRepeat:"no-repeat"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        marginLeft: 20

                    }}
                >

                    {/* <div style={{
                width:"100%",
                textAlign:"center"
            }}> */}
                    <p
                        style={{
                            fontSize: 24,
                            fontWeight: 700,
                            margin: "10px 0px",
                        }}
                    >
                        Ooops...
                    </p>
                    <p style={{
                        fontSize: 20,
                        fontWeight: 500,
                        margin: "20px 0px",
                        color: "#333A3A"
                    }}>Something went wrong please try later</p>
                    <button
                        style={{
                            backgroundColor: "#3980FD",
                            border: 0,
                            // width: "50%",
                            cursor: "pointer",
                            height: 40,
                            borderRadius: 10,
                            color: "#ffffff",
                            fontSize: 20,
                            fontWeight: 500,
                        }}
                        onClick={() => { window.location.reload() }}
                    >
                        Refresh
                    </button>
                </div>

            </div>
        </div>
        //    </Card> 
    );
}

export default ServerError

export const SectionServerErr=()=>( <Card sx={{padding:"20px"}}>
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height:  300,
            padding:20,
        }}>
           
           
                <div className='section-err-img' style={{
                    width:"50%"
                }}>
                    <img src={sectionErrImg} alt="sectionErr" height={"100%"} width={"100%"}/>
                </div>
                <div 
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        marginLeft: 20

                    }}
                >

                    {/* <div style={{
                width:"100%",
                textAlign:"center"
            }}> */}
                
                    <p
                        style={{
                            fontSize: 24,
                            fontWeight: 700,
                            margin: "10px 0px",
                        }}
                    >
                        Ooops...
                    </p>
                    <p style={{
                        fontSize: 20,
                        fontWeight: 500,
                        margin: "20px 0px",
                        color: "#333A3A"
                    }}>Something went wrong please try later</p>
                    <button
                        style={{
                            backgroundColor: "#3980FD",
                            border: 0,
                            // width: "50%",
                            cursor: "pointer",
                            height: 40,
                            borderRadius: 10,
                            color: "#ffffff",
                            fontSize: 20,
                            fontWeight: 500,
                        }}
                        onClick={() => { window.location.reload() }}
                    >
                        Refresh
                    </button>
                </div>
            
        </div>
    </Card>)
